import * as React from 'react';

import type {DueDateUnit as DelayUnit} from 'nutshell-core/types';

import {AlertBox} from '../alert-box/alert-box';
import {FormWrapperWithButtons} from '../form/form-wrapper-with-buttons';

import {DelayInput} from './delay-input';

type Props = {
    onModalClose: () => void;
    selectedDelayUnit: DelayUnit;
    setSelectedDelayUnit: (selection: DelayUnit) => void;
    inputValue: number;
    setInputValue: (value: number) => void;
    saveChanges: () => void;
    onClearSaveComplete: () => any;
    isSaving: boolean;
    editionId: string;
    editionName: string;
    confirmationDialog?: React.ComponentType<any>;
};

export function EditDelayModal(props: Props) {
    const [shouldCheckForConfirmation, setShouldCheckForConfirmation] =
        React.useState<boolean>(false);
    const [isConfirmingChanges, setIsConfirmingChanges] = React.useState<boolean>(false);
    const [canceledChanges, setCanceledChanges] = React.useState<boolean>(false);

    const ConfirmationDialog = props.confirmationDialog ? props.confirmationDialog : undefined;

    function handleCancelChanges() {
        setShouldCheckForConfirmation(false);
        setCanceledChanges(true);
        setTimeout(() => {
            setCanceledChanges(false);
            setIsConfirmingChanges(false);
        }, 1000);
    }

    return (
        <>
            <AlertBox onClose={props.onModalClose}>
                <FormWrapperWithButtons
                    title='Edit this delay'
                    subtitle='Send the next message after...'
                    onSaveClick={() => {
                        if (!props.confirmationDialog) {
                            props.saveChanges();
                        } else {
                            setShouldCheckForConfirmation(true);
                            // Fake that the save button is saving
                            setIsConfirmingChanges(true);
                        }
                    }}
                    onCancel={props.onModalClose}
                    isSaving={props.isSaving || isConfirmingChanges}
                    errorSaving={canceledChanges}
                    saveButtonDisabled={!props.inputValue}
                    onClearSaveComplete={props.onClearSaveComplete}
                >
                    <DelayInput
                        onSelectChange={props.setSelectedDelayUnit}
                        selectedOption={props.selectedDelayUnit}
                        onInputChange={props.setInputValue}
                        inputValue={props.inputValue}
                    />
                </FormWrapperWithButtons>
            </AlertBox>
            {shouldCheckForConfirmation && ConfirmationDialog ? (
                <ConfirmationDialog
                    editionId={props.editionId}
                    editionName={props.editionName}
                    delay={{unit: props.selectedDelayUnit, timespan: props.inputValue}}
                    onCancel={handleCancelChanges}
                    onConfirmSaveChanges={() => {
                        setIsConfirmingChanges(false);
                        setShouldCheckForConfirmation(false);
                        props.saveChanges();
                    }}
                />
            ) : undefined}
        </>
    );
}
